import { Helmet } from 'react-helmet-async'

import { type LandingLocale, absoluteLocalizedUrl, alternateOgLocaleFor, ogLocaleFor } from '@/navigation/locale'
import { isSsgLocaleFreePath } from '@/navigation/ssgEligibility'

type LocaleSeoLinksProps = {
    /** Locale-free path, e.g. `/` or `/aprender/foo` */
    path: string
    locale: LandingLocale
}

/**
 * Canonical + og URL/locale. Hreflang / og:locale:alternate only for SSG'd paths.
 * Each tag must be a direct Helmet child — React 19 + react-helmet-async drops Fragment children.
 */
export function LocaleSeoLinks({ path, locale }: LocaleSeoLinksProps) {
    const canonical = absoluteLocalizedUrl(path, locale)
    const emitHreflang = isSsgLocaleFreePath(path)

    return (
        <Helmet>
            <link rel='canonical' href={canonical} />
            {emitHreflang ? <link rel='alternate' hrefLang='es' href={absoluteLocalizedUrl(path, 'es')} /> : null}
            {emitHreflang ? <link rel='alternate' hrefLang='en' href={absoluteLocalizedUrl(path, 'en')} /> : null}
            {emitHreflang ? (
                <link rel='alternate' hrefLang='x-default' href={absoluteLocalizedUrl(path, 'es')} />
            ) : null}
            {emitHreflang ? <meta property='og:locale:alternate' content={alternateOgLocaleFor(locale)} /> : null}
            <meta property='og:locale' content={ogLocaleFor(locale)} />
            <meta property='og:url' content={canonical} />
        </Helmet>
    )
}
